import { mapStores } from 'pinia'
import { useFileStoreStore } from '@/features/filestore/FileStore.store'
import { useFileListStore } from '@/stores/FileList.store'
import SessionExpired from '@/dialogs/SessionExpired.vue'
import { getUser } from '@/api/api'

export default {
  computed: {
    ...mapStores(useFileStoreStore, useFileListStore)
  },
  methods: {
    sessionCheck() {
      getUser().then(async (user) => {
        if ((this.rootStore.loggedIn && user === null) || user?.mfaPending) {
          this.$modal.show(SessionExpired, null, {
            width: 300,
            height: 'auto'
          })
          this.rootStore.logout()
          await this.$router.push({ name: 'home' })
          this.rootStore.setHome()
          this.fileStoreStore.clear()
          this.fileListStore.clear()
        }
      })
    }
  }
}
